import { Link } from 'react-router-dom';
import { useCookieConsent } from '../lib/CookieConsentContext';

/**
 * Vaste banner tot keuze; analytics pas na expliciete opt-in (Fase 2).
 */
export function CookieConsentBanner() {
  const { status, acceptNecessaryOnly, acceptAnalytics } = useCookieConsent();

  if (status !== 'unknown') {
    return null;
  }

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[100] border-t-2 border-border bg-surface-card px-4 py-4 shadow-[0_-8px_24px_rgba(0,0,0,0.12)] sm:px-6"
      role="dialog"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-desc"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0 flex-1">
          <p id="cookie-banner-title" className="text-sm font-semibold text-text">
            Cookies en statistiek
          </p>
          <p id="cookie-banner-desc" className="mt-1 text-sm text-text-muted">
            We gebruiken noodzakelijke technieken voor inloggen en sessie; na inactiviteit kun je automatisch worden
            uitgelogd (zie cookie- en privacybeleid). Optioneel meten we anonieme paginaweergaves via onze eigen server
            (geen Google Analytics).{' '}
            <Link to="/cookies" className="font-medium text-primary hover:underline">
              Meer over cookies
            </Link>
            {' · '}
            <Link to="/privacy" className="font-medium text-primary hover:underline">
              Privacy
            </Link>
          </p>
        </div>
        <div className="flex shrink-0 flex-col gap-2 sm:flex-row sm:items-center">
          <button
            type="button"
            onClick={acceptNecessaryOnly}
            className="rounded-lg border border-border bg-surface px-4 py-2.5 text-sm font-medium text-text transition-colors hover:bg-surface-card"
          >
            Alleen noodzakelijk
          </button>
          <button
            type="button"
            onClick={acceptAnalytics}
            className="rounded-lg bg-primary px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-alt"
          >
            Sta analytics toe
          </button>
        </div>
      </div>
    </div>
  );
}
